import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 12l6-6v12l-6-6z" }));
export default createSvgIcon(iconPath, "ArrowFillLeft");
//# sourceMappingURL=ArrowFillLeftIcon.js.map